import { CommonContainer } from 'src/models/Common'
import ContentStack from 'src/api/contentStack'
import { observable } from 'mobx'
import { IS_BROWSER } from 'src/utils/application'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import { getTransformedCSPageData } from 'src/utils/contentStackUtils'
/**
 * ContentStackContainer class extends CommonContainer.
 * This class represents a container for ContentStack data.
 */
class ContentStackContainer extends CommonContainer {
  @observable marketingData = {}
  @observable contentStackPage = {}
  microFrontendConfig = undefined
  errorCodes = null

  constructor(props) {
    super(props)
  }

  /**
   * Sets the marketingData property to the provided props.
   *
   * @param {Object} props - The marketing data to set.
   */
  setMarketingData = props => {
    this.marketingData = props
  }

  getCSPageEntry = async props => {
    const { isToSkipContextLoad = false } = props
    // This is to avoid duplicate calls while calling CS Wrapper component in multiple places in a page
    if (IS_BROWSER && this.contentStackPage.url == props.url) {
      return
    }

    this.contentStackPage = {
      url: props.url,
      entries: undefined,
      isLoading: true,
    }

    const loadParams = {
      endPointName: 'csPageEntry',
      contextName: props.contextName,
      curLocaleFromUrl:
        props.context?.curLocaleFromUrl || getLocaleCodeFromUrl() || 'en-US',
      csQueryString: props.queryParams,
    }

    const fetchAllEntries = async () => {
      const equinoxRes = await this.fetchResponse({
        ...loadParams,
        csEntryName: 'equinox_pages',
      })
      const equinoxData = equinoxRes?.csPageEntry || equinoxRes
      return equinoxData
    }

    let response = {}

    response = await fetchAllEntries()

    if (this.isSuccessResponse(response)) {
      response = getTransformedCSPageData(response, props.url)
      this.contentStackPage = response
    }
    return response
  }

  getMicroFrontendConfig = async props => {
    const referenceId = 'microfrontend_config'
    const uid = ''
    const options = {
      isToSkipIncludes: true,
      includeFallback: true,
    }

    if (this.microFrontendConfig) {
      return this.microFrontendConfig
    }

    const response = await ContentStack.getReference(
      referenceId,
      uid,
      this.props,
      options
    )
    return response
  }

  getErrorCodes = () => {
    if (this.errorCodesPromise) return this.errorCodesPromise
    this.errorCodesPromise = ContentStack.getErrorcodes()
      .then(r => r?.cserrorcodes || [])
      .catch(e => {
        this.errorCodesPromise = null
        throw e
      })
    return this.errorCodesPromise
  }
}

const contentStackContainer = new ContentStackContainer()

export { contentStackContainer }
export default contentStackContainer
